import { runClientComponent } from '../../_common/client/client-component-runner';
import { ProductRoomFitSheetComponent } from './product-room-fit-sheet.component';

runClientComponent({ ProductRoomFitSheetComponent });
